export default "__VITE_ASSET__Cub2uG_Y__"